import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-resizable/css/styles.css';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import Select from 'react-select';
import { apiService } from '../../../../../services/apiService';
import { toast } from 'react-toastify';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import InterviewCaseCats from '../../../../../components/catalog/InterviewCaseCats';
import AssignmentsGeneralCase from '../../GenaralCase/BasicTabs/AssignmentsGeneralCase';
import GeneralCaseDisccuss from '../../GenaralCase/BasicTabs/GeneralCaseDisccuss';
import GeneralCaseKnowledge from '../../GenaralCase/BasicTabs/GeneralCaseKnowledge';
import GeneralCaseHistory from '../../GenaralCase/BasicTabs/GeneralCaseHistory';
import CaseAllDetails from '../../GenaralCase/BasicCaseTabs/CaseAllDetails';
// import { Autocomplete, LoadScript } from '@react-google-maps/api';

// const libraries = ["places"];
function InterviewIntake() {
    const userId = localStorage.getItem('userid');
    const navigate = useNavigate();
    const location = useLocation();
    const parts_location = location.pathname.split("/");
    const caseSlug = parts_location[2] || null;
    const taskId = parts_location[3] || null;
    const caseId = parts_location[4] || null;
    const [reloadChild, setReloadChild] = useState(0);
    const [activeTab, setActiveTab] = useState("overview");
    const [activeTabCase, setActiveTabCase] = useState("task");
    const [showCase, setShowCase] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const handleCloseSuccess = () => setShowSuccess(false);
    const [formData, setFormData] = useState({
        Q0020: '',
        Q0021: '',
        Q0030: '',
        Q0040: '',
        Q0050: '',
        Q0060: '',
        Q0070: '',
        Q0080: '',
        Q0090: '',
        Q0100: '',
        Q0110: '',
        Q0130: '',
        Q0140: '',
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [submitloader, setSubmitloader] = useState(false);
    const [submitloader2, setSubmitloader2] = useState(false);

    const [reqList, setRequestList] = useState([]);
    const [ownerGroupList, setOwnerGroup] = useState([]);
    const [bussEntryList, setBussEntry] = useState([]);
    const [selectedBussEntry, setSelectedBussEntry] = useState(null);
    const [solutionsList, setSolutionList] = useState([]);
    const [selectedSolutions, setSelectedSolutions] = useState(null);
    const [caseTypeList, setCaseTypeList] = useState([]);
    const [selectedCaseType, setSelectedCaseType] = useState(null);
    const [caseSubTypeList, setCaseSubTypeList] = useState([]);
    const [skillsList, setSkillsList] = useState([]);
    const [selectedSkills, setSelectedSkills] = useState(null);
    const [relKbList, setRelKbList] = useState([]);
    const [relCaseList, setRelCaseList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allDataSubmit, setAllDataSubmit] = useState([]);
    const [refetchData, setRefetchData] = useState(null);

    const [showRefBack, setShowRefBack] = useState(false);
    const handleCloseRefBack = () => setShowRefBack(false);
    // const [paginatedata, setPaginateData] = useState({});
    // const [currentPage, setCurrentPage] = useState(1);
    const fetchFormData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`/cases/${caseSlug}/${caseId}`);
            if (response && response.success === true) {
                setAllData(response.data);
                setAllDataSubmit(response);
                setShowCase(response.data?.can_see_case);
                setRefetchData(response.data.form_data);
                setFormData({
                    Q0020: response.data?.form_data?.Q0020?.raw_value || response.data?.triage_form_data?.Q0040?.raw_value,
                    Q0021: response.data?.form_data?.Q0021?.raw_value || response.data?.triage_form_data?.Q0050?.raw_value,
                    Q0030: response.data?.form_data?.Q0030?.raw_value || response.data?.triage_form_data?.Q0070?.raw_value,
                    Q0040: response.data?.form_data?.Q0040?.raw_value || response.data?.triage_form_data?.Q0080?.raw_value,
                    Q0050: response.data?.form_data?.Q0050?.raw_value || response.data?.triage_form_data?.Q0090?.raw_value,
                    Q0060: response.data?.form_data?.Q0060?.raw_value || response.data?.triage_form_data?.Q0100?.raw_value,
                    Q0070: response.data?.form_data?.Q0070?.raw_value || response.data?.triage_form_data?.Q0110?.raw_value,
                    Q0080: response.data?.form_data?.Q0080?.raw_value,
                    Q0090: response.data?.form_data?.Q0090?.raw_value,
                    Q0100: response.data?.form_data?.Q0100?.raw_value,
                    Q0110: response.data?.form_data?.Q0110?.raw_value,
                    Q0130: response.data?.form_data?.Q0130?.raw_value,
                    Q0140: response.data?.form_data?.Q0140?.raw_value || response.data?.intake_form_data?.Q0100?.raw_value,
                })
            }else{
                if(response.error === "permission_denied"){
                    toast.error(response.message || "Permission Denied")
                    navigate("/dashboard")
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [caseSlug, caseId, navigate]);

    useEffect(() => {
        fetchFormData();
    }, [fetchFormData]);
    useEffect(() => {
        if (!formData) return;

        // Business Entry
        if (formData.Q0030 && bussEntryList.length > 0) {
            const selected = bussEntryList.find(x => x.value === Number(formData.Q0030));
            selected && setSelectedBussEntry(selected);
        }

        // Solutions Entry
        if (formData.Q0040 && solutionsList.length > 0) {
            const selected = solutionsList.find(x => x.value === Number(formData.Q0040));
            selected && setSelectedSolutions(selected);
        }

        // Case Entry
        if (formData.Q0050 && caseTypeList.length > 0) {
            const selected = caseTypeList.find(x => x.value === Number(formData.Q0050));
            selected && setSelectedCaseType(selected);
        }

        if (formData.Q0070 && skillsList.length > 0) {
            const existingIds = typeof formData.Q0070 === 'string'
                ? formData.Q0070.split(',').map(id => Number(id.trim()))
                : Array.isArray(formData.Q0070) 
                    ? formData.Q0070.map(id => Number(id))
                    : [Number(formData.Q0070)];

            const selectedccs = skillsList.filter(option => 
                existingIds.includes(option.value)
            );
            setSelectedSkills(selectedccs);
        }

        // if (formData && formData.Q0140 && relCaseList?.length > 0) {

        //     let values = [];

        //     const raw = formData.Q0140;

        //     if (Array.isArray(raw)) {
        //         values = raw.map(v => Number(v));
        //     } else if (typeof raw === "string") {
        //         values = raw.split(",").map(v => Number(v.trim()));
        //     } else if (typeof raw === "number") {
        //         values = [raw];
        //     } else {
        //         values = [];
        //     }

        //     // const selectedRelCase = values
        //     //     .map(num => relCaseList.find(item => item.value === num))
        //     //     .filter(Boolean);

        //     // setSelectedRelCase(selectedRelCase);
        // }

    }, [formData, reqList, skillsList, ownerGroupList, bussEntryList, solutionsList, caseTypeList, caseSubTypeList, relKbList, relCaseList]);
    
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`internal-users`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.full_name,
                    }));
                    setRequestList(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`ownership-groups`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setOwnerGroup(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`case_holdings`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setBussEntry(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed" && (allData?.triage_form_data?.Q0060?.raw_value || allData?.case?.assignment_group_id)){
            const param ={
                ownership_group_id : allData?.triage_form_data?.Q0060?.raw_value || allData?.case?.assignment_group_id
            }
            const fetchData = async () => {
                const response = await apiService.postRequest(`solutions/list`, param);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setSolutionList(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(selectedSolutions && allData?.status_string && allData.status_string !== "completed" && selectedSolutions?.value){
            const fetchData = async () => {
                const response = await apiService.postRequest(`case-types/list/${selectedSolutions && selectedSolutions.value}`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setCaseTypeList(options);
                }
            };
            fetchData();
        }
    }, [selectedSolutions, allData]);
    useEffect(() => {
        if(selectedCaseType && allData?.status_string && allData.status_string !== "completed" && selectedCaseType?.value){
            const fetchData = async () => {
                const response = await apiService.postRequest(`case-sub-types/list/${selectedCaseType && selectedCaseType.value}`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.name,
                    }));
                    setCaseSubTypeList(options);
                }
            };
            fetchData();
        }
    }, [selectedCaseType, allData]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const params = {
                'task_id' : Number(taskId)
            }
            const fetchData = async () => {
                const response = await apiService.postRequest(`cc-users`, params);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.email,
                    }));
                    setSkillsList(options);
                }
            };
            fetchData();
        }
    }, [allData, taskId]);
    useEffect(() => {
        if(allData?.status_string && allData.status_string !== "completed"){
            const fetchData = async () => {
                const response = await apiService.postRequest(`related-articles-dropdown`);
                if (response.success) {
                    const options = response.data.map((role) => ({
                        value: role.id,
                        label: role.kb_number,
                    }));
                    setRelKbList(options);
                }
            };
            fetchData();
        }
    }, [allData]);
    useEffect(() => {
        if(selectedCaseType && allData){
            const fetchData = async () => {
            const param ={
                department_id : Number(allData?.triage_form_data?.Q0060?.raw_value) ,
                case_type_id : selectedCaseType?.value,
            }
            const response = await apiService.postRequest(`related-cases-dropdown`, param);
            if (response.success) {
                const options = response.data.map((role) => ({
                    value: role.id,
                    label: role.kb_number,
                }));
                setRelCaseList(options);
            }
        };
        fetchData();
        }
    }, [selectedCaseType, allData]);
    
    const handleSkills = (selectedOptions) => {
        setSelectedSkills(selectedOptions); // Update the selected options for display
    
        // Extract values from the selected options array
        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    
        // Update formData with the selected values (as an array)
        setFormData((prevFormData) => ({
            ...prevFormData,
            Q0070: selectedValues,
        }));
        if (errors.Q0070) {
            setErrors({ ...errors, Q0070: '' });
        }
    };

    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
        setFormData({ ...formData, [name]: value });
    };

    
    const validateForm = () => {
        const newErrors = {};
        if (!formData.Q0020) newErrors.Q0020 = "Impact is required.";
        if (formData.Q0021 && formData.Q0021.length < 3) {
            newErrors.Q0021 = "Location must be at least 3 characters long.";
        }else if (formData.Q0021 && formData.Q0021.length > 200) {
            newErrors.Q0021 = 'Location be less than 200 characters long.';
        }
        if (!formData.Q0030) newErrors.Q0030 = "Business Entity is required.";
        if (!formData.Q0040) newErrors.Q0040 = "Solution is required.";
        if (!formData.Q0050) newErrors.Q0050 = "Case Type is required.";
        if (!formData.Q0060) newErrors.Q0060 = "Case Sub Type is required.";
        if (!formData.Q0080) newErrors.Q0080 = "Due Date is required.";
        if (!formData.Q0090) newErrors.Q0090 = "Resolution Code is required.";
        if (!formData.Q0100) newErrors.Q0100 = "Resolution Notes is required.";
        if (formData.Q0100 && formData.Q0100.length < 3) {
            newErrors.Q0100 = "Resolution notes must be at least 3 characters long.";
        }else if (formData.Q0100 && formData.Q0100.length > 2000) {
            newErrors.Q0100 = 'Resolution notes be less than 2000 characters long.';
        }
        if(Number(userId) !== Number(allData?.case?.requested_by_id)){
            if (!formData.Q0110) newErrors.Q0110 = "Private work notes is required.";
            if (formData.Q0110 && formData.Q0110.length < 3) {
                newErrors.Q0110 = "Private work notes must be at least 3 characters long.";
            }else if (formData.Q0110 && formData.Q0110.length > 2000) {
                newErrors.Q0110 = 'Private work notes be less than 2000 characters long.';
            }
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e, status) => {
        e.preventDefault();
        if (!validateForm()) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        if(status === 'draft'){
            setSubmitloader2(true);
        }else{
            setSubmitloader(true);
        }
        try {
            const formDataToSend = new FormData();

            // Add other form fields
            for (const key in formData) {
                if (formData[key] !== undefined && formData[key] !== null && formData[key] !== '') {
                    formDataToSend.append(key, formData[key]);
                }
            }

            if(status === 'draft'){
                formDataToSend.append('status', status);
            }else{
                formDataToSend.delete('status');
            }

            const response = await apiService.postRequest(`cases/${caseSlug}/${caseId}/submit`, formDataToSend);

            // Check if the response indicates success
            if (response && response.success === true) {
                setShowSuccess(true)
                setErrors({});
                setErrorMessage('');
                fetchFormData();
                setReloadChild(prev => prev + 1);
                toast(response.message || "Submitted Successfully !")
                setSuccessMessage(response.message || "Submitted Successfully !")
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
            setSubmitloader2(false); // Stop loader
        }
    };


    const [formDataBack, setFormDataBack] = useState({
        Q0220 : '',
    });
    const [errorsBack, setErrorsBack] = useState({});

    const handleInputChangeBack = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrorsBack((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
        setFormDataBack({ ...formDataBack, [name]: value });
    };
    const validateFormBack = (action) => {
        const newErrors = {};
        if(action === "route_back"){
            if (!formDataBack.Q0220) newErrors.Q0220 = "Reason  is required.";
        }
        setErrorsBack(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmitBack = async (e, action, Q0190) => {
        e.preventDefault();

        if (!validateFormBack(action, Q0190)) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }

        setSubmitloader(true);
        try {
            
            const jsonParams = {
                ...formData,...formDataBack,
                action,
                Q0190,
            };
            const response = await apiService.postRequest(`cases/${caseSlug}/${caseId}/submit`, jsonParams);

            // Check if the response indicates success
            if (response && response.success === true) {
                toast(response.message || "Submitted Successfully !");
                navigate("/task/my-cases");
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
        }
    };
    

    // const [autocomplete, setAutocomplete] = useState(null);
    // const [locations, setLocations] = useState("");
    // console.log("locations", locations)
    // const onLoad = (auto) => setAutocomplete(auto);

    // const onPlaceChanged = () => {
    //     if (autocomplete) {
    //     const place = autocomplete.getPlace();
    //     setLocations(place.formatted_address);
    //     console.log(place);
    //     }
    // };
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <InterviewCaseCats onReload={reloadChild}/>
            <div className='content_container_validate' style={{ flexGrow: 1 }}>
                <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate('/task/my-task')}>Task</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> In Progress<FontAwesomeIcon className='angleright' icon={faAngleRight} /> {allData?.case?.case_formatted_id}</span>
                </Grid>
                <Grid size={{sm:12}} container className="main_jobseeker tab_controllers">
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../../../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :
                    <Tabs
                        activeKey={activeTabCase}
                        onSelect={(key) => setActiveTabCase(key)}
                        defaultActiveKey="task"
                        id="uncontrolled-tab-example" className="mb-4 drafttabs_tabs"
                    >
                        <Tab eventKey="task" title="Task">
                        <Grid size={{xs:12}} container justifyContent="space-between" className="jobseekerhead border_botomer mario_fixers">
                            <Grid container flexDirection="column">
                                <h3>Intake Form</h3>
                                <span>Interview Booking</span>
                            </Grid>
                        </Grid>
                        <Grid size={{sm:12}} container>
                            <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className="tab_controllers">
                                <Tabs
                                    activeKey={activeTab}
                                    onSelect={(key) => setActiveTab(key)}
                                    defaultActiveKey="overview"
                                    id="uncontrolled-tab-example" className="drafttabs_tabs mt-4"
                                    >
                                    <Tab eventKey="overview" title="Overview">
                                        {allData && allData.status_string !== "completed" ?
                                        <Grid size={{sm:12}} container alignItems="center">
                                            <form className='w-100 pt-4' >
                                                <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                    {/* <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Requested By<small className='red_starimpo'>*</small></span>
                                                        <input value={allData?.case?.requested_by_name} disabled />
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Requested For<small className='red_starimpo'>*</small></span>
                                                        <input value={allData?.case?.requested_for_name} disabled/>
                                                    </Grid>
                                                    <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Re-assignment Count <span style={{color:"red"}}> *</span></span>
                                                        <input value={allData?.case?.reassignment_count} disabled/>
                                                    </Grid> */}
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Type of Interview<span style={{color:"red"}}> *</span></span>
                                                        <select value={formData.Q0020} name='Q0020' onChange={handleInputChange} >
                                                            <option value="">Select</option>
                                                            <option value="Phone">Phone</option>
                                                            <option value="Video">Video</option>
                                                        </select>
                                                        {errors.Q0020 && <p style={{color:"Red"}}>{errors.Q0020}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Type of Employment<span style={{color:"red"}}> *</span></span>
                                                        <select value={formData.Q0030} name='Q0030' onChange={handleInputChange} >
                                                            <option value="">Select</option>
                                                            <option value="FTE">FTE</option>
                                                            <option value="W2">W2</option>
                                                            <option value="C2C">C2C</option>
                                                            <option value="Unknown">Unknown</option>
                                                        </select>
                                                        {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="coustom_textarea">
                                                        <span>What is the Hourly Rate Offered?<span style={{color:"red"}}> *</span></span>
                                                        <input name='Q0040' value={formData.Q0040} onChange={handleInputChange}/>
                                                        {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Have you received hourly rate confirmation?<span style={{color:"Red"}}> *</span></span>
                                                        <div className='d-flex align-items-center main_radioregister'>
                                                            <input
                                                                className='ms-0'
                                                                // disabled={!showSubmits}
                                                                type="radio" 
                                                                name="Q0050"
                                                                value="Yes"
                                                                checked={formData.Q0050  === "Yes"} 
                                                                onChange={handleInputChange} 
                                                            />Yes
                                                            <input
                                                                className='ms-4'
                                                                // disabled={!showSubmits}
                                                                type="radio" 
                                                                name="Q0050"
                                                                value="No"
                                                                checked={formData.Q0050  === "No"} 
                                                                onChange={handleInputChange} 
                                                            />No
                                                        </div>
                                                        {errors.Q0050 && <p style={{color:"Red"}}>{errors.Q0050}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Does this interview perform a coding test?<span style={{color:"red"}}> *</span></span>
                                                        <select value={formData.Q0060} name='Q0060' onChange={handleInputChange} >
                                                            <option value="">Select</option>
                                                            <option value="Yes">Yes</option>
                                                            <option value="No">No</option>
                                                            <option value="Not Sure">Not Sure</option>
                                                        </select>
                                                        {errors.Q0060 && <p style={{color:"Red"}}>{errors.Q0060}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Primary ServiceNow Skills</span>
                                                        <Select
                                                            // isDisabled={!showgroupselect || !showSubmits}
                                                            isMulti
                                                            className="basic-single select_withsearch"
                                                            classNamePrefix="select"
                                                            value={selectedSkills}
                                                            defaultValue={null}
                                                            name="Q0070"
                                                            options={skillsList}
                                                            onChange={handleSkills}
                                                        />
                                                        {errors.Q0070 && <p style={{color:"Red"}}>{errors.Q0070}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Interviewers<span style={{color:"red"}}> *</span></span>
                                                        <Select
                                                            className="basic-single select_withsearch"
                                                            classNamePrefix="select"
                                                            value={selectedBussEntry}
                                                            defaultValue={null}
                                                            name="Q0030"
                                                            options={bussEntryList}
                                                            onChange={(selectedOption) => {
                                                                setSelectedBussEntry(selectedOption);
                                                                handleInputChange({
                                                                    target: {
                                                                        name: "Q0030",
                                                                        value: selectedOption ? selectedOption.value : ""
                                                                    }
                                                                });
                                                            }}
                                                        />
                                                        {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Staffing Agency Involved?<span style={{color:"red"}}> *</span></span>
                                                        <select value={formData.Q0030} name='Q0030' onChange={handleInputChange} >
                                                            <option value="">Select</option>
                                                            <option value="Yes">Yes</option>
                                                            <option value="No">No</option>
                                                            <option value="Unknown">Unknown</option>
                                                        </select>
                                                        {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="coustom_textarea">
                                                        <span>Staffing Agency Name<span style={{color:"red"}}> *</span></span>
                                                        <input name='Q0040' value={formData.Q0040} onChange={handleInputChange}/>
                                                        {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Implementation Partner Involved?<span style={{color:"red"}}> *</span></span>
                                                        <select value={formData.Q0030} name='Q0030' onChange={handleInputChange} >
                                                            <option value="">Select</option>
                                                            <option value="Yes">Yes</option>
                                                            <option value="No">No</option>
                                                            <option value="Unknown">Unknown</option>
                                                        </select>
                                                        {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="coustom_textarea">
                                                        <span>Implementation Partner Name<span style={{color:"red"}}> *</span></span>
                                                        <input name='Q0040' value={formData.Q0040} onChange={handleInputChange}/>
                                                        {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>End Client Involved?<span style={{color:"red"}}> *</span></span>
                                                        <select value={formData.Q0030} name='Q0030' onChange={handleInputChange} >
                                                            <option value="">Select</option>
                                                            <option value="Yes">Yes</option>
                                                            <option value="No">No</option>
                                                            <option value="Unknown">Unknown</option>
                                                        </select>
                                                        {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="coustom_textarea">
                                                        <span>End Client Name<span style={{color:"red"}}> *</span></span>
                                                        <input name='Q0040' value={formData.Q0040} onChange={handleInputChange}/>
                                                        {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                        <span>Confidence Level<span style={{color:"red"}}> *</span></span>
                                                        <select value={formData.Q0030} name='Q0030' onChange={handleInputChange} >
                                                            <option value="">Select</option>
                                                            <option value="No">No</option>
                                                            <option value="Low">Low</option>
                                                            <option value="Average">Average</option>
                                                            <option value="High">High</option>
                                                        </select>
                                                        {errors.Q0030 && <p style={{color:"Red"}}>{errors.Q0030}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="coustom_textarea">
                                                        <span>ServiceNow PDI URL<span style={{color:"red"}}> *</span></span>
                                                        <input name='Q0040' value={formData.Q0040} onChange={handleInputChange}/>
                                                        {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="coustom_textarea">
                                                        <span>ServiceNow PDI Username<span style={{color:"red"}}> *</span></span>
                                                        <input name='Q0040' value={formData.Q0040} onChange={handleInputChange}/>
                                                        {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                                    </Grid>
                                                    <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column" className="coustom_textarea">
                                                        <span>Password<span style={{color:"red"}}> *</span></span>
                                                        <input name='Q0040' value={formData.Q0040} onChange={handleInputChange}/>
                                                        {errors.Q0040 && <p style={{color:"Red"}}>{errors.Q0040}</p>}
                                                    </Grid>
                                                    {errorMessage && <div style={{ color: 'red', margin: '10px 0px' }}>{errorMessage}</div>}
                                                    {allDataSubmit?.can_submit === true &&
                                                    <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-3">
                                                        <button type="button" onClick={() => setShowRefBack(true)} className='registersendbtn1'>Route Back</button>
                                                        <button type="button" className='registersendbtn1' onClick={(e) => handleSubmit(e, "draft")}>{submitloader2 ? <img src={require('../../../../../assets/pinkloader.gif')} alt=''/> : 'Save As Draft'}</button>
                                                        <button type="button" className='registersendbtn2' onClick={(e) => handleSubmit(e, "")}>{submitloader && !showRefBack ? <img src={require('../../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}</button>
                                                    </Grid>}
                                                </Grid>
                                            </form>
                                        </Grid>:
                                        <Grid size={{sm:12}} container alignItems="center">
                                            <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Requested By</span>
                                                    <p>{allData?.case?.requested_by_name}</p>
                                                </Grid>
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Requested For</span>
                                                    <p>{allData?.case?.requested_for_name}</p>
                                                </Grid>
                                                <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Re-assignment Count</span>
                                                    <p> {allData?.case?.reassignment_count} </p>
                                                </Grid>
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Impact</span>
                                                    <p>{refetchData?.Q0020?.display_value}</p>
                                                </Grid>
                                                {refetchData?.Q0021?.display_value &&
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Location</span>
                                                    <p>{refetchData?.Q0021?.display_value}</p>
                                                </Grid>}
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Business Entity</span>
                                                    <p>{refetchData?.Q0030?.display_value}</p>
                                                </Grid>
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Solution</span>
                                                    <p>{refetchData?.Q0040?.display_value}</p>
                                                </Grid>
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Case Type</span>
                                                    <p>{refetchData?.Q0050?.display_value}</p>
                                                </Grid>
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Case Sub Type</span>
                                                    <p>{refetchData?.Q0060?.display_value}</p>
                                                </Grid>
                                                {refetchData?.Q0070?.display_value && Array.isArray(refetchData.Q0070.display_value) && refetchData.Q0070.display_value.length > 0 &&
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>CC Others</span>
                                                    {refetchData?.Q0070?.display_value.map((tag, index) => (
                                                            <p className='mb-1 mt-0' key={index}>{tag}</p>
                                                        ))
                                                    }
                                                </Grid>}
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Due Date</span>
                                                    <p>{refetchData?.Q0080?.display_value || "No Data"}</p>
                                                </Grid>
                                                <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                    <span>Resolution Code</span>
                                                    <p>{refetchData?.Q0090?.display_value || "No Data"}</p>
                                                </Grid>
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Resolution Notes</span>
                                                    <p>{refetchData?.Q0100?.display_value || "No Data"}</p>
                                                </Grid>
                                                {refetchData?.Q0110?.display_value &&
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Private Work Notes</span>
                                                    <p>{refetchData?.Q0110?.display_value || "No Data"}</p>
                                                </Grid>}
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Attachments</span>
                                                    <Grid size={{xs:12}} container justifyContent="space-between">
                                                        {refetchData?.Q0120?.display_value.map((file, index) => (
                                                            <span className='mt-2' key={index}>{index +1}. <Link to={`${file}`} target='_blank'>View</Link></span>
                                                        ))}
                                                    </Grid>
                                                </Grid>
                                                {refetchData?.Q0130?.display_value && Array.isArray(refetchData.Q0130.display_value) && refetchData.Q0130.display_value.length > 0 &&
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Related Knowledge Articles</span>
                                                    {refetchData?.Q0130?.display_value.map((tag, index) => (
                                                            <p className='mb-1 mt-0' key={index}>{tag}</p>
                                                        ))
                                                    }
                                                </Grid>}
                                                {refetchData?.Q0140?.display_value && Array.isArray(refetchData.Q0140.display_value) && refetchData.Q0140.display_value.length > 0 &&
                                                <Grid size={{xs:12}} container flexDirection="column">
                                                    <span>Related Cases</span>
                                                    {refetchData?.Q0140?.display_value.map((tag, index) => (
                                                            <p className='mb-1 mt-0' key={index}>{tag}</p>
                                                        ))
                                                    }
                                                </Grid>}
                                            </Grid>
                                        </Grid>}
                                    </Tab>
                                    <Tab eventKey="assignment" title="Assignments">
                                        {activeTab === "assignment" && <AssignmentsGeneralCase />}
                                    </Tab>
                                    <Tab eventKey="discussions" title="Discussions">
                                        {activeTab === "discussions" && <GeneralCaseDisccuss />}
                                    </Tab>
                                    <Tab eventKey="knowledge" title="Knowledge">
                                        {activeTab === "knowledge" && <GeneralCaseKnowledge />}
                                    </Tab>
                                    <Tab eventKey="history" title="History" style={{ flexGrow: 1 }}>
                                        {activeTab === "history" && <GeneralCaseHistory />}
                                    </Tab>
                                </Tabs>
                            </Grid>
                        </Grid>
                    </Tab>
                        {showCase && 
                        <Tab eventKey="case" title="Case">
                            {activeTabCase === "case" && <CaseAllDetails/>}
                        </Tab>
                        }
                    </Tabs>}
                </Grid>
                <Modal
                    show={showRefBack} 
                    onHide={handleCloseRefBack}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    >
                    <Modal.Header closeButton style={{border:"none"}}>
                        <h5 className='modal_pinkheader'>Route Back</h5>
                    </Modal.Header>
                    <Modal.Body>
                        <form className='d-flex flex-column roleback_mainmodal'>
                            <div className='d-flex flex-column rollback_textarea'>
                                <span className='mt-0'>Enter a reason to Route Back <small className='justify_astrickt'>*</small></span>
                                <textarea maxLength={4001} name='Q0220' value={formDataBack.Q0220} onChange={handleInputChangeBack}/>
                                {errorsBack.Q0220 && <p style={{color:"Red"}}>{errorsBack.Q0220}</p>}
                                {errorMessage && <p style={{ color: 'red', margin: '10px 0px' }}>{errorMessage}</p>}
                            </div>
                            <div className='d-flex justify-content-end'>
                                <button type='submit' className='registersendbtn2 mb-2 ' onClick={(e) => handleSubmitBack(e, "route_back", "Route Back")}>
                                    {submitloader ? <img src={require('../../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </Modal.Body>
                </Modal>
                <Modal
                    show={showSuccess} 
                    onHide={handleCloseSuccess}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    >
                    <Modal.Header closeButton style={{border:"none"}}>
                        
                    </Modal.Header>
                    <Modal.Body>
                        <div className='d-flex w-100 text-center flex-column align-items-center modal_register'>
                            <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                            <h3>Successfully!</h3>
                            <small>{successMessage}</small>
                            <button onClick={handleCloseSuccess}>OK</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    </div>
  )
}

export default InterviewIntake
